import { render, staticRenderFns } from "./external-resource-view.vue?vue&type=template&id=4cf5bf83&scoped=true"
import script from "./external-resource-view.vue?vue&type=script&lang=js"
export * from "./external-resource-view.vue?vue&type=script&lang=js"
import style0 from "./external-resource-view.vue?vue&type=style&index=0&id=4cf5bf83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf5bf83",
  null
  
)

export default component.exports